import { buildTemplatesManager, } from '../../templates/templates-manager.js';
/**
 * A manager in which product templates can be registered and selected based on a list of conditions and a priority index.
 * @returns (ProductTemplatesManager<Content>) A new product template manager.
 */
export function buildProductTemplatesManager() {
    return buildTemplatesManager();
}
